import {
  Box, DialogContent, styled, Typography,
} from '@mui/material';

import CustomInput from 'components/CustomInput';

export const PromotionContainer = styled(DialogContent)(({ theme }) => ({
  minWidth: '500px',
  marginTop: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
}));

export const StyledCustomInput = styled(CustomInput)(({ theme }) => ({
  marginRight: theme.spacing(0.5),
  flex: 1,
}));

export const ButtonCodeField = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
  alignContent: 'end',
  marginBottom: theme.spacing(0.1),
}));

export const Label = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  margin: theme.spacing(4, 0, 1.5, 0),
  fontWeight: 'bold',
}));

export const DiscountsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const DiscountField = styled(Box)(() => ({
  display: 'flex',
  textAlign: 'center',
  alignItems: 'center',
}));
